var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { Box, InputLabel, MenuItem as MuiMenuItem, Select as MuiSelect, } from '@mui/material';
import AddressCard from './AddressCard';
import { useTranslation } from 'react-i18next';
import { Link as OriginalLink } from 'react-router-dom';
var Select = styled(MuiSelect)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &.MuiInput-root {\n    &:before {\n      border: none;\n    }\n    &:after {\n      border: none;\n    }\n\n    &:hover {\n      &:not(.Mui-disabled) {\n        &:before {\n          border: none;\n        }\n        &:after {\n          border: none;\n        }\n      }\n    }\n  }\n\n  .MuiSelect-select {\n    &.MuiInputBase-input.MuiInput-input:focus {\n      background-color: transparent;\n    }\n    .MuiPaper-root {\n      min-height: 150px;\n      border: none;\n    }\n  }\n"], ["\n  &.MuiInput-root {\n    &:before {\n      border: none;\n    }\n    &:after {\n      border: none;\n    }\n\n    &:hover {\n      &:not(.Mui-disabled) {\n        &:before {\n          border: none;\n        }\n        &:after {\n          border: none;\n        }\n      }\n    }\n  }\n\n  .MuiSelect-select {\n    &.MuiInputBase-input.MuiInput-input:focus {\n      background-color: transparent;\n    }\n    .MuiPaper-root {\n      min-height: 150px;\n      border: none;\n    }\n  }\n"])));
var MenuItem = styled(MuiMenuItem)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  &.MuiMenuItem-root {\n    padding: 0;\n    padding-bottom: 3px;\n\n    .MuiPaper-root {\n      min-height: 150px;\n    }\n\n    &.Mui-selected {\n      .MuiPaper-root {\n        background-color: rgba(33, 33, 33, 0.08);\n      }\n    }\n  }\n"], ["\n  &.MuiMenuItem-root {\n    padding: 0;\n    padding-bottom: 3px;\n\n    .MuiPaper-root {\n      min-height: 150px;\n    }\n\n    &.Mui-selected {\n      .MuiPaper-root {\n        background-color: rgba(33, 33, 33, 0.08);\n      }\n    }\n  }\n"])));
var Link = styled(OriginalLink)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 0.75rem;\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 0.5rem;\n"], ["\n  font-size: 0.75rem;\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 0.5rem;\n"])));
var RoasterAddressSelect = function (_a) {
    var _b = _a.role, role = _b === void 0 ? 'roaster' : _b, type = _a.type, roaster = _a.roaster, onChange = _a.onChange;
    var t = useTranslation().t;
    var _c = React.useState(getDefaultValue(type, roaster)), value = _c[0], setValue = _c[1];
    var addresses = React.useMemo(function () {
        var _a, _b;
        if (type === 'delivery')
            return (_a = roaster.deliveryAddresses) !== null && _a !== void 0 ? _a : [];
        return (_b = roaster.billingAddresses) !== null && _b !== void 0 ? _b : [];
    }, [type, roaster]);
    var changeAddress = React.useCallback(function (event) {
        var value = event.target.value;
        setValue(value);
        var address = addresses.find(function (address) { return address.id === value; });
        if (address)
            onChange(address);
    }, [addresses, onChange]);
    React.useEffect(function () {
        // for initailize
        var address = addresses.find(function (address) { return address.id === value; });
        if (address)
            onChange(address);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    var manageAddressUrl = React.useMemo(function () {
        if (role === 'admin') {
            return "/admin/roasters/".concat(roaster.id, "/").concat(type, "_addresses");
        }
        return "/roaster/edit/".concat(type, "_addresses");
    }, [type, role, roaster.id]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { sx: {
                border: 'solid 1px rgba(145, 158, 171, 0.32)',
                '&:hover': { border: 'solid 1px rgba(0, 0, 0, 0.87)' },
                borderRadius: 1,
                position: 'relative',
            } },
            React.createElement(Box, { display: "flex", justifyContent: "space-between", alignItems: "center" },
                React.createElement(InputLabel, { focused: true, shrink: true, id: "roaster-address-select", sx: {
                        backgroundColor: function (theme) {
                            return theme.customPalette.background.default;
                        },
                        color: function (theme) { return theme.customPalette.text.secondary; },
                        position: 'absolute',
                        left: '12px',
                        top: '-8px',
                        padding: '0 8px',
                    } }, t("labels.".concat(type, "Address")))),
            React.createElement(Select, { fullWidth: true, variant: "standard", value: value, inputProps: {
                    disableUnderline: true,
                }, onChange: changeAddress }, addresses.map(function (address) { return (React.createElement(MenuItem, { key: address.id, value: address.id },
                React.createElement(AddressCard, { address: address, showDefault: false }))); }))),
        React.createElement(Link, { to: manageAddressUrl, target: "_blank" }, t('pages.roasterAddresses.title'))));
};
export default RoasterAddressSelect;
var getDefaultValue = function (type, roaster) {
    var _a, _b;
    var addresses = (_a = (type === 'billing'
        ? roaster.billingAddresses
        : roaster.deliveryAddresses)) !== null && _a !== void 0 ? _a : [];
    return ((_b = addresses.find(function (address) { return address.isDefault; })) === null || _b === void 0 ? void 0 : _b.id) || '';
};
var templateObject_1, templateObject_2, templateObject_3;
